import { render } from "./moh706.vue?vue&type=template&id=6efc7bf0&scoped=true"
import script from "./moh706.vue?vue&type=script&lang=js"
export * from "./moh706.vue?vue&type=script&lang=js"

import "./moh706.vue?vue&type=style&index=0&id=6efc7bf0&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6efc7bf0"]])

export default __exports__